import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  redirect,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";
import ScrollToTop from "./ScrollToTop";
import Modal from "./components/core/Modal/Modal";
import AboutUs from "./pages/AboutUs/AboutUs";
import ChannelsPage from "./pages/Channels/ChannelsPage";
import Home from "./pages/Home/Home";
import OurSolutionsPage from "./pages/OurSolutions/OurSolutionsPage";
import ResourcesPage from "./pages/Resources/ResourcesPage";
import { APP_PATH, routePath } from "./routes/route";
import "./styles/common.scss";
import TermsOfService from "./pages/TermsAndPrivacy/TermsOfService";
import PrivacyPolicy from "./pages/TermsAndPrivacy/PrivacyPolicy";
import ContactUsForm from "./components/common/ContactUs/ContactUsForm";
import useModalContext from "./components/core/Modal/useModalContext";
import SubscriptionPage from "./pages/Subscription/SubscriptionPage";
import FreeTrialForm from "./pages/Subscription/components/FreeTrialForm";
import LandingPage from "./pages/LandingPage/LandingPage";
import ThankYou from "./pages/ThankYou/ThankYou";

function App() {
  const modalContext = useModalContext();
  const openModal = () => {
    modalContext.setBodyWithFooter(
      <ContactUsForm
        closeModal={() => closeModal()}
        className="modalContactForm"
      ></ContactUsForm>
    );
    modalContext.setCloseIconVis(true);
    modalContext.setOnBackdropClick(() => closeModal);
    modalContext.setShow(true);
  };
  const closeModal = () => {
    modalContext.setShow(false);
  };
  return (
    <>
      <div className="sticky_requestADemo" onClick={openModal}>
        Request a demo
      </div>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <ToastContainer />
          <Modal />
          <Routes>
            <Route
              path={routePath.landingpage.path}
              element={<LandingPage />}
            />
            <Route path={routePath.home.path} element={<Home />} />
            <Route path={routePath.aboutus.path} element={<AboutUs />} />
            <Route
              path={routePath.resources.path}
              element={<ResourcesPage />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.blog}`}
              element={<ResourcesPage page="blog" />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.ebook}`}
              element={<ResourcesPage page="ebook" />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.newsletter}`}
              element={<ResourcesPage page="newsletter" />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.webinars}`}
              element={<ResourcesPage page="webinars" />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.casestudy}`}
              element={<ResourcesPage page="casestudy" />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.videos}`}
              element={<ResourcesPage page="videos" />}
            />
            <Route
              path={`${routePath.resources.path}${routePath.resources.child.contactus}`}
              element={<ResourcesPage page="contactus" />}
            />
            <Route
              path={routePath.oursolutions.path}
              element={<OurSolutionsPage />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.bfsi}`}
              element={<OurSolutionsPage page="bfsi" />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.contactus}`}
              element={<OurSolutionsPage page="contactus" />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.dthentertainment}`}
              element={<OurSolutionsPage page="dthentertainment" />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.education}`}
              element={<OurSolutionsPage page="education" />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.realestate}`}
              element={<OurSolutionsPage page="realestate" />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.hospitality}`}
              element={<OurSolutionsPage page="hospitality" />}
            />
            <Route
              path={`${routePath.oursolutions.path}${routePath.oursolutions.child.retail}`}
              element={<OurSolutionsPage page="retail" />}
            />
            <Route path={routePath.channels.path} element={<ChannelsPage />} />
            <Route
              path={`${routePath.channels.path}${routePath.channels.child.contactus}`}
              element={<ChannelsPage page="contactus" />}
            />
            <Route
              path={`${routePath.channels.path}${routePath.channels.child.googlercs}`}
              element={<ChannelsPage page="googlercs" />}
            />
            <Route
              path={`${routePath.channels.path}${routePath.channels.child.sms}`}
              element={<ChannelsPage page="sms" />}
            />
            <Route
              path={`${routePath.channels.path}${routePath.channels.child.email}`}
              element={<ChannelsPage page="email" />}
            />
            <Route
              path={`${routePath.channels.path}${routePath.channels.child.voiceapis}`}
              element={<ChannelsPage page="voiceapis" />}
            />
            <Route
              path={`${routePath.channels.path}${routePath.channels.child.whatsapp}`}
              element={<ChannelsPage page="whatsapp" />}
            />
            <Route path={routePath.thankyou.path} element={<ThankYou />} />
            <Route
              path={routePath.termsofservice.path}
              element={<TermsOfService />}
            />
            <Route
              path={routePath.privacypolicy.path}
              element={<PrivacyPolicy />}
            />
            <Route
              path={routePath.subscription.path}
              element={<SubscriptionPage />}
            />
            <Route
              path={`${routePath.subscription.path}${routePath.subscription.child.freetrialform}`}
              element={<FreeTrialForm />}
            />
            <Route
              path={routePath.invalid}
              element={<Navigate to={APP_PATH} replace />}
            />
            {/* <Route
              path={routePath.invalid}
              loader={() => {
                console.log("Invalid");
                return redirect(APP_PATH);
              }}
            /> */}
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
